import React, { useEffect, useState } from "react";
import {
   
    FormGroup,
    Modal,
    ModalBody,
    Form,
    
  
    Spinner,
} from "reactstrap";


import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { Icon, Col, Button } from "../../../../components/Component";
function UserUpdatedata({ ...props }) {
    const [UData, setUData] = useState([])
    const [loading, setLoading] = useState(false);
    const { errors, register, handleSubmit } = useForm();
    const [viewModal, setViewModal] = useState(false);

    const [formData, setFormData] = useState({
        catType: "",
        userName: "",
        password: "",
        email: "",
        phoneno: ""



    });
    const onFormSubmit = async () => {

        /*//console.log(data)*/

        /*setLoading(true)*/


        const sendData = {
            OrgId: Number(1),
            UserId: Number(props.userId),
            LoginName: formData.userName,
            PhoneNo: formData.phoneno,
            EmailId: formData.email,
        }
        //console.log(sendData)


        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/UpdateUserDetails', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
             
                  
                    if (data === "Done") {
                        Swal.fire({
                            icon: "success",
                            title: "Done",
                            text: "Added Option Successfully",
                            focusConfirm: false,
                        });
                        props.setupdatestate(props.updatestate +1 )
                        getdata()
                        setViewModal(false)

                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: "Data Already Exit",
                            text: data,
                            focusConfirm: false,
                        });
                        getdata()
                    }
                })


    };  

    const getdata = async () => {
        const sendData = {
            OrgId: Number(1),
            CatgTypeId: Number(props.catgTypeId)
        }

        //console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/GetDetailsuser', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setFormData({
                        ...formData, userName: data.loginName,
                        phoneno: data.phoneNo,
                        email: data.emailId
                    })
                })


    };
    const onInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        //console.log(formData)
    };
    useEffect(() => {
        getdata()
    }, [props.catgTypeId])

   
   

    return (
        <>
            <Button color="success" className="btn-icon" onClick={() => setViewModal(true)}>
                <Icon name="update"></Icon> <p style={{ marginRight: 10, color: "white" }}> Update Details</p>
            </Button>
            <Modal isOpen={viewModal} toggle={() => setViewModal(false)} className="modal-dialog-centered" size="lg">
                <ModalBody>
                    <a
                        href="#cancel"
                        onClick={(ev) => {
                            ev.preventDefault();
                            setViewModal(false);
                        }}
                        className="close"
                    >
                        <Icon name="cross-sm"></Icon>
                    </a>
                    <div className="p-2">
                        <h5 className="title">Add State</h5>
                        <div className="mt-4">
                            <Form className="row gy-4 mt-4" onSubmit={handleSubmit(onFormSubmit)}>
                               
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">User Name</label>
                                        <input
                                            className="form-control"

                                            type="text"
                                            name="userName"
                                            defaultValue={formData.userName}
                                            onChange={(e) => onInputChange(e)}
                                            placeholder="Enter User Name"
                                        />
                                        {errors.userName && <span className="invalid">{errors.userName.message}</span>}
                                    </FormGroup>
                                </Col>
                               
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Phone No</label>
                                        <input
                                            className="form-control"
                                            type="number"
                                            name="phoneno"
                                            maxLength="12"
                                            onChange={(e) => onInputChange(e)}
                                            placeholder="Enter Phone Number"
                                            defaultValue={formData.phoneno}
                                        />
                                        {errors.phoneno && <span className="invalid">{errors.phoneno.message}</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <label className="form-label">Email Id</label>
                                        <input
                                            className="form-control"

                                            type="email"
                                            name="email"
                                            defaultValue={formData.email}
                                            onChange={(e) => onInputChange(e)}
                                            placeholder="Enter Email Id"
                                        />
                                        {errors.email && <span className="invalid">{errors.email.message}</span>}
                                    </FormGroup>
                                </Col>

                                <Col size="12">
                                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                        <li>
                                            <Button color="success" size="md" type="submit">
                                                {loading ? <Spinner size="sm" color="light" /> : <><Icon name="update" /> Update</>}
                                            </Button>
                                        </li>
                                        <li>
                                            <a
                                                href="#cancel"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                    setViewModal(false);
                                                }}
                                                className="link link-light"
                                            >
                                                Cancel
                                            </a>
                                        </li>
                                    </ul>
                                </Col>
                            </Form>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};

export default UserUpdatedata;
